// extracted by mini-css-extract-plugin
export default {"notAssigned_tr":"style_notAssigned_tr__l0VjF","title":"style_title__YXvDW"};